module.exports = __webpack_public_path__ + "static/img/cloth.29dc70e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tools/cloth.png
// module id = 446
// module chunks = 1